<template>    
    <v-container fluid  class="main">
      <LeftMenu/>  
       <v-layout row wrap>  
           <Progress :show="this.showProgress" />
           <v-flex xs1></v-flex>
            <v-flex xs11>
                <v-row
                    class="mb-6"
                    no-gutters
                >
                    <v-col md="7" class="pa-2" >
                        <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                                <v-combobox
                                :items="suppliers"
                                label="Select Supplier"
                                v-model="purchase.supplier"
                                item-text="name"
                                single-line
                                return-object
                                >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.contactPerson }}  - {{ data.item.name }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    {{ data.item.contactPerson }}  - {{ data.item.name }}
                                </template>
                                </v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-text-field v-model="this.purchase.status" :disabled="true" label="Status"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md2/>
                            <v-flex xs12 sm6 md2>
                                
                            </v-flex>


                            <v-flex xs12 sm6 md3>
                                <DatePicker picker-label="Purchase Date" :date-value="purchase.purchaseDate" @dateSelected="purchase.purchaseDate=$event" />                              
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm3 md3 >
                                <v-combobox	
                                    :items="currencyListWithText"	
                                    label="Select Currency"	
                                    v-model="purchase.currency"	
                                    item-text="text"	
                                    single-line	
                                    return-object>	
                                </v-combobox>	
                            </v-flex>                   
                            <v-flex xs12 sm6 md1>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>
                                                           
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>   


                            <v-flex xs12 sm6 md3>	
                                
                            </v-flex> 
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md4/>
                            <v-flex xs12 sm6 md3>
                               
                            </v-flex> 
                            <v-flex xs12 sm6 md1/>

                            <v-flex xs12 sm6 md11>
                                <v-textarea v-model="purchase.explanation"  :outlined="true"
                                :auto-grow="true" :clearable="true"
                                label="Explanation"></v-textarea>
                            </v-flex>   
                            <v-flex xs12 sm6 md11/>
                        </v-layout>
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        
                            <v-layout row wrap>                                         
                                <v-flex xs12 >
                                    <Documents :documents="this.purchase.documents" master-category="OFFER" :folder-id="this.purchase.folderId"
                                               :parentRecord="this.purchase.id" :readonly="true" @documentsChanged="getPurchase" />
                                </v-flex>                                            
                            </v-layout>      
                    </v-col>
                </v-row>
                <v-row
                    class="mb-6"
                    no-gutters
                >
                    <v-col md="7" class="pa-2" >
                        <v-layout wrap >   
                            <v-flex v-if="purchase.id" xs12 sm6 md6>
                                <v-combobox
                                :items="materialList"
                                label="Select Material"
                                v-model="newMaterial.material"
                                item-text="materialName"     
                                item-value="id"       
                                v-on:change="materialSelected"                     
                                chips
                                return-object
                                ></v-combobox>
                            </v-flex>   
                            <v-flex v-if="purchase.id" xs12 sm6 md1>
                                <v-text-field v-model="newMaterial.quantity"   label="Quantity"></v-text-field>
                            </v-flex>
                            
                            <v-flex v-if="purchase.id" xs12 sm6 md2>
                                <v-currency-field :key="newMaterial.id" v-model="newMaterial.price"   label="Price"></v-currency-field>
                            </v-flex>
                            <v-flex v-if="purchase.id" xs12 sm6 md2>                              
                                <v-btn v-if="isPurchaseEditable(purchase)" color="primary" dark class="mb-2" @click="addMaterial(purchase)">Add To Purchase</v-btn>
                            </v-flex> 
                    
                            
                            <v-flex v-if="purchase.id && loaded" xs12 sm6 md12>
                                <v-data-table
                                    :key="materialTableKey"
                                    :headers="materialHeaders"
                                    :items="purchase.materials"
                                    item-key="material.id"
                                    sort-by="material.materialName"                                    
                                    class="elevation-1"
                                    hide-default-footer
                                    >
                                <template v-slot:item.materialAction="{ item }">                                                  
                                    <v-icon   
                                    :disabled="!isPurchaseEditable(purchase)"                                 
                                    @click="deleteMaterial(item)"
                                    >
                                    mdi-delete
                                    </v-icon>
                                </template>
                                </v-data-table>
                            </v-flex>  
                            <v-spacer></v-spacer>
                            <v-flex xs12 sm6 md7></v-flex> 
                            <v-flex xs12 sm6 md3>
                                <b>Purchase Total Amount : </b>
                            </v-flex>  
                            <v-flex xs12 sm6 md2 >
                                <b>{{ totalPurchasePriceFormatted }} {{purchaseCurrency}}</b>
                            </v-flex>  
                            <v-flex xs12 sm6 md12 > &nbsp;</v-flex>
                            <v-flex xs12 sm6 md10 />
                            <v-flex xs12 sm6 md2>
                                <v-btn v-if="isPurchaseEditable(purchase)" color="success" dark class="mb-2" @click="save">Save Purchase</v-btn>   
                            </v-flex> 
                        </v-layout>
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        <v-layout wrap >   
                                <v-flex v-if="purchase.id && loaded" xs12 sm6 md12>
                                    <v-data-table
                                        :key="deliveriesTableKey"
                                        :headers="purchaseDeliveriesHeaders"
                                        :items="purchase.deliveries"
                                        item-key="id"
                                        sort-by="deliveryDate"                                    
                                        class="elevation-1"
                                        hide-default-footer
                                        >
                                        <template v-slot:top>
                                            <v-toolbar flat color="white">
                                                <v-toolbar-title>Deliveries</v-toolbar-title>
                                            </v-toolbar>
                                        </template>    
                                        <template v-slot:item.goToDetails="{ item }">              
                                            <v-icon                  
                                            @click="goToDetails(item)">
                                            mdi-send
                                            </v-icon>                
                                        </template> 
                                    </v-data-table>
                                </v-flex>  
                            <v-spacer></v-spacer>
                        
                        </v-layout>     
                    </v-col>
                </v-row>
            </v-flex>
       </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import Progress from '../../components/Progress';
import Documents from '../../views/Documents';
import breadcrumbs from '../../store/breadcrumbs.js'
import formatPrice from '../../helpers/formatter';
const PURCHASE_API_URL = 'manufacture/purchases';
const SUPPLIERS_API_URL = 'definitions/suppliers';
const CURRENCIES_API_URL = 'definitions/currencies';
const MATERIALS_API_URL = 'definitions/materials';
export default {
    props: {
    },
    components:{
      LeftMenu,
      DatePicker,
      Documents,
      Progress
    },
    data () {
      return {
        loaded: false,
        showProgress : false,
        suppliers:[],
        purchase : {},
        materialTableKey : 1,
        deliveriesTableKey : 2,
        materialList:[],
        currencyList: [],
        totalPurchasePrice: 0,
        purchaseCurrency : '',
        newMaterial:{}
      }
    },
    computed: {      
        materialHeaders(){
            return [   
                { text: 'Material',  value: 'material.materialName'  },      
                { text: 'Purchased',  value: 'purchasedQuantity', align: 'center'  },
                { text: 'Delivered',  value: 'deliveredQuantity', align: 'center'  },
                { text: 'Price(' + this.purchase.currency.code +')',  value: 'priceFormatted' , align: 'right' }, 
                { text: 'Actions', value: 'materialAction', sortable: false },
            ]
        },
        purchaseDeliveriesHeaders(){
            return [   
                { text: '',align: 'left',sortable: false,value: 'goToDetails'},
                { text: 'Date',  value: 'deliveryDate'  },      
                { text: 'Supplier',  value: 'supplier.name'  }, 
            ]
        },
        totalPurchasePriceFormatted(){
            return formatPrice(this.totalPurchasePrice);
        },
        convertedText(){
            return "Converted ("+this.purchase.currency.code+')';
        },
        currencyListWithText(){
            return this.currencyList.map((item) => {
                return {
                id: item.id,
                code: item.code,
                text: item.code+' - '+item.text          
                };
            })
        },
        
    },
    created () {
        if(this.$route.params.id != 'new'){
            this.getPurchase(); 
        }else{
            this.purchase.id= 0;
            this.purchase.status = "NEW";
            this.totalPurchasePrice = 0;
            this.purchase.supplier = {};
            let currentSupplier = breadcrumbs.getters.getSupplier;
            let crumbs = breadcrumbs.getters.getBreadCrumps;
            if( crumbs && crumbs.length>0 && currentSupplier){
                this.purchase.supplier = currentSupplier;
            }
        }
        this.getSuppliers();
        this.getCurrencies()
        this.getMaterialList();
        this.newMaterial = {}; 
    },
    methods: {
        async getPurchase(){
          this.$axios.get(this.$apiurl + PURCHASE_API_URL+'/'+ this.$route.params.id)
            .then(response => {
                this.purchase = response.data;
                this.purchaseCurrency = this.purchase.currency.code;
                this.updateBreadCrumbs(response.data);
                this.getPurchaseMaterials();
            }) 
            .catch(error => {
                console.log(error);
            });   
            await this.getPurchaseDeliveries();
        },
        goToDetails(item){
            this.$router.push('/deliveries/'+item.id);
        },
        isPurchaseEditable(purchase){
            return purchase.status=='NEW' || purchase.status=='OPEN';
        },
        getSuppliers(){     
          this.$axios.get(this.$apiurl + SUPPLIERS_API_URL)
            .then(response => {
                this.suppliers = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
        },   
        save () {
            if(!this.purchase.supplier || !this.purchase.supplier.id){
                alert('Supplier cannot be empty!');
                return;
            } 
            if(!this.purchase.status){
                alert('Status cannot be empty!');
                return;
            } 
            if(!this.purchase.purchaseDate){
                alert('Purchase date cannot be empty!');
                return;
            } 
            if(!this.purchase.currency){
                alert('Currency  cannot be empty!');
                return;
            }
            if (this.$route.params.id != 'new') {        
                this.updatePurchase(this.purchase);
            } else {
                this.addPurchase(this.purchase);         
            }  
        },
        addPurchase(item){
            this.showProgress = true;
            this.$axios.post(this.$apiurl + PURCHASE_API_URL, {
                supplierId: item.supplier.id,  
                currencyId: item.currency.id,
                purchaseDate: item.purchaseDate,
                status: item.status,
                explanation: item.explanation,
                materials: item.materials
            })
            .then(response => {        
                if (response.status === 201) {
                    this.purchase = response.data;
                    this.updateBreadCrumbs(response.data);
                    this.showProgress = false;
                    this.$radio.$emit('success', {message:'Purchase Created Successfully'});
                    this.$router.push('/purchases/'+this.purchase.id);
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        updatePurchaseStatus(status){
            this.$axios.post(this.$apiurl + PURCHASE_API_URL+'/'+this.$route.params.id+'/status/'+status, {})
            .then(response => {        
                if (response.status === 200) {
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
            },
        async addMaterial(purchase){
            await this.$axios.post(this.$apiurl + PURCHASE_API_URL+'/'+this.$route.params.id+'/materials', {
                materialId: this.newMaterial.material.id,        
                price: this.newMaterial.price ? this.newMaterial.price : 0,
                quantity: this.newMaterial.quantity ? this.newMaterial.quantity : 1
            })
            .then(response => {        
                if (response.status === 201) {
                    this.$radio.$emit('success', {message:'Material Added Sucessfully'});
                } 
            }) 
            .catch(error => {
                console.log(error);
            });      
            this.newMaterial = {};
            await this.getPurchaseMaterials();      
        },
        updatePurchase(item){
            this.$axios.put(this.$apiurl + PURCHASE_API_URL, {
                id: item.id,
                supplierId: item.supplier.id,  
                currencyId: item.currency.id,
                purchaseDate: item.purchaseDate,
                status: item.status,
                explanation: item.explanation,
                materials: item.materials
            })
            .then(response => {
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Purchase Saved Sucessfully'});
                }         
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        async getPurchaseMaterials(){  
            
            this.purchase.materials = [];   
            this.totalPurchasePrice = "";
            
            
            await this.$axios.get(this.$apiurl + PURCHASE_API_URL+'/'+this.$route.params.id+'/materials')
            .then(response => {
                if(response.data && response.data.length>0){
                    this.purchase.materials = response.data;              
                    this.purchase.materials.map((item) => {   
                        item.priceFormatted = formatPrice(item.price);


                        var deliveredItemList = [];//this.purchase.deliveries.filter(x => x.materials && x.materials.filter(y => y.material.id == item.id).length > 0 );
                        var deliveredItemQuantity = 0;
                        if(deliveredItemList && deliveredItemList.length>0){

                            var arrayLength = deliveredItemList.length;
                            for (var i = 0; i < arrayLength; i++) {
                                var delivery = deliveredItemList[i];
                                if(delivery.materials){
                                    for (var j = 0; j < delivery.materials.length; j++) {
                                        deliveredItemQuantity += delivery.materials[j].quantity;
                                    }
                                }
                            }
                        }
                        item.purchasedQuantity = item.quantity;
                        item.deliveredQuantity = deliveredItemQuantity;

                        return item;    
                    });
                    this.totalPurchasePrice =  this.purchase.materials.reduce((acc, item) => acc + item.price, 0); 
                }
            }) 
            .catch(error => {
                console.log(error);
            });   
            
            this.loaded = true;
            
        },
        async getPurchaseDeliveries(){  
            this.purchase.deliveries = [];
        
            await this.$axios.get(this.$apiurl + PURCHASE_API_URL+'/'+this.$route.params.id+'/deliveries')
            .then(response => {
                if(response.data && response.data.length>0){
                    this.purchase.deliveries = response.data;  
                }
            }) 
            .catch(error => {
                console.log(error);
            });   
        },
        getMaterialList(){     
            this.$axios.get(this.$apiurl + MATERIALS_API_URL )
                .then(response => {
                    this.materialList = response.data;                          
                }) 
                .catch(error => {
                    console.log(error);
                });                         
        }, 
        materialSelected(item){  
            this.newMaterial.quantity = 1;
            this.newMaterial.price = 0;
        },
        updateBreadCrumbs(item){
            let purchaseText = item.id;
            
            breadcrumbs.dispatch('setBreadCrumps', [
                                      { text: 'Suppliers', disabled: false, href: '/#/suppliers'},
                                      { text: item.supplier.name, disabled: true, href: '/#/suppliers/'+item.supplier.id},
                                      { text: 'Purchase ' +purchaseText, disabled: true } // placeholder
                                  ]);
        },
        async deleteMaterial(item){                  
            if(confirm('Are you sure you want to delete this material?')){ 
                await this.$axios.delete(this.$apiurl + PURCHASE_API_URL+'/'+ this.$route.params.id +'/materials/'+item.id)
                .then(response => {        
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Material Deleted Successfully'});
                } 
                }) 
                .catch(error => {
                console.log(error);
                });            
                await this.getPurchaseMaterials();                 
            }     
        },
        getCurrencies(){     
            this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
        }, 
    }
}
</script>